export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const FETCH_SCHEDULES = 'FETCH_SCHEDULES';
export const EDIT_SCHEDULES = 'EDIT_SCHEDULES';
export const DELETE_SCHEDULES = 'DELETE_SCHEDULES';
